// Dấu nhận diện SẢN PHẨM của hệ đang chạy kernel — cho những chỗ kernel trước đây ghi cứng «CNV Work» /
// `/cnvwork.png` mà người dùng NHÌN THẤY (màn chờ Chat, lời nhắc «mở app … trên điện thoại»).
//
// Đọc `branding.product_name` / `branding.product_logo` của @host/tenant. Cố ý KHÔNG đọc `app_name` /
// `branding.logo`: Core khai `app_name: 'CNV Connect'` + `branding.logo: '/logo.png'` (logo trang quản trị),
// nhưng app điện thoại nhân viên Core dùng vẫn là CNV Work — đọc hai khoá đó là đổi chữ của Core.
// Hệ không khai (Core, Work) ⇒ giữ nguyên «CNV Work» + `/cnvwork.png` như trước. Site Connect khai trong
// admin/src/config/tenant.js của cnvconnect-saas.
import hostTenant from '@host/tenant';

const branding = (hostTenant && hostTenant.branding) || {};

function pick(v, fallback) {
  return typeof v === 'string' && v.trim() ? v.trim() : fallback;
}

export const PRODUCT_NAME = pick(branding.product_name, 'CNV Work');
export const PRODUCT_LOGO = pick(branding.product_logo, '/cnvwork.png');

// Tâm bản đồ khi CHƯA có điểm nào để canh khung (form chọn vị trí dự án, bản đồ check-in, bản đồ dự án).
// Hệ không khai ⇒ giữa Hà Nội như trước (Work, Core); Site Connect khai Toronto — khách Canada mở form tạo
// dự án mà bản đồ nằm ở Hà Nội (thấy khi chụp ảnh docs 11/10/2026).
function pickLatLng(v, fallback) {
  return Array.isArray(v) && v.length === 2 && v.every((n) => Number.isFinite(Number(n)))
    ? [Number(v[0]), Number(v[1])]
    : fallback;
}
export const MAP_DEFAULT_CENTER = pickLatLng(branding.map_default_center, [21.028511, 105.804817]);
